<template>
  <div class="goods-cell-b" @click="onTap">
    <div class="image-section">
      <img :src="item.thumbnailImg || item.spuImg || item.thumbnailUrl || item.imageUrl || item.appImg || item.wechatImg" class="goods-img" />
      <div v-if="item.inStock === 0" class="status-mask">
        <div class="status-circle">商品<br/>售罄</div>
      </div>
    </div>
    <div class="info-section">
      <div class="goods-name">{{ item.name }}</div>
      <div class="price-row">
        <span class="final-price">{{ item.finalPrice | currency(false) }}</span>
        <div v-if="item.couponProduct != null && item.couponProduct.couponSkuAmount != null" class="coupon-price-view">
          <span class="cpv-label">券后价</span>
          <span class="cpv-price">{{ item.couponProduct.couponSkuAmount | currency(false) }}</span>
        </div>
        <span v-if="item.storeProfitPrice !== null" class="profit-tag-wrapper">
          <img src="@/assets/common/icon_earn.png" class="profit-icon-img" />
          <span class="earn-money-text">{{ item.storeProfitPrice | currency(false) }}</span>
        </span>
      </div>
      <div class="activity-row">
        <template v-if="item.activitySort && item.activitySort.length">
          <template v-for="(tagType, index) in item.activitySort">
            <span v-if="tagType === 'buyFree'" :key="index" class="gift-tag">买赠</span>
            <div v-else-if="tagType === 'coupon' && item.couponProduct" :key="index" class="coupon-view">
              <div class="cv-tag">
                <span class="cv-tag-text">券</span>
              </div>
              <div v-if="item.couponProduct.couponMessageStr" class="cv-detail">
                <span class="cv-detail-text">{{ item.couponProduct.couponMessageStr }}</span>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <span v-if="item.activitySort && item.activitySort.includes('buyFree')" class="gift-tag">买赠</span>
          <div v-if="item.couponProduct" class="coupon-view">
            <div class="cv-tag">
              <span class="cv-tag-text">券</span>
            </div>
            <div v-if="item.couponProduct.couponMessageStr" class="cv-detail">
              <span class="cv-detail-text">{{ item.couponProduct.couponMessageStr }}</span>
            </div>
          </div>
        </template>
      </div>
      <div class="bottom-row">
        <!-- 上架/下架状态按钮 -->
        <div v-if="item.status === 1" class="btn btn-left-status" @click.stop>
          <van-icon name="success" class="true-icon" />
          <span>已上架</span>
        </div>
        <div v-else class="btn btn-left" @click.stop="onLeftBtnClick">
          <span>上架小店</span>
        </div>
        <!-- 分享按钮 -->
        <div class="btn btn-right" @click.stop="onShareClick">
          <span>立即分享</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoodsCellB",
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    onTap() {
      this.$emit("click", this.item);
    },
    onLeftBtnClick() {
      this.$emit("clickLeft", this.item);
    },
    onShareClick() {
      if (this.item.status === 0) {
        this.$toast("请先将商品上架小店后再分享");
        return;
      }
      this.$emit("clickShare", this.item);
    }
  }
};
</script>

<style lang="less" scoped>
.goods-cell-b {
  display: flex;
  background-color: #fff;
  padding: 12px 8px;
  border-radius: 4px;
  margin-bottom: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;
  text-align: left;
}
.image-section {
  width: 90px;
  height: 90px;
  position: relative;
  background-color: #f7f8fa;
  border-radius: 4px;
  overflow: hidden;
  margin-right: 12px;
  flex-shrink: 0;
  .goods-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.status-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
}
.status-circle {
  width: 85%;
  height: 85%;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 16px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.3;
}
.info-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-width: 0;
}
.goods-name {
  font-size: 14px;
  color: #323233;
  line-height: 1.4;
  height: 38px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.price-row {
  display: flex;
  align-items: center;
  margin-top: 4px;
}
.final-price {
  font-size: 16px;
  color: #333;
  font-weight: bold;
  margin-right: 8px;
}
.coupon-price-view {
  display: flex;
  align-items: center;
  margin-right: 6px;
  .cpv-label {
    font-size: 10px;
    color: #999999;
    flex-shrink: 0;
  }
  .cpv-price {
    color: #ff2828;
    font-size: 14px;
    font-weight: 700;
    font-family: DINAlternate-Bold, DIN, sans-serif;
    margin-left: 2px;
  }
}
.profit-tag-wrapper {
  display: flex;
  vertical-align: middle;
}
.profit-icon-img {
  width: 14px;
  height: 14px;
  object-fit: contain;
  margin-right: 3px;
  vertical-align: middle;
  display: inline-block;
}
.earn-money-text {
  color: #f81a27;
  font-weight: bold;
  font-size: 11px;
  vertical-align: middle;
  display: inline-block;
  line-height: 14px;
  margin-top: 1px;
}
.activity-row {
  min-height: 15px;
  margin-top: 2px;
  display: flex;
  align-items: center;
}
.gift-tag {
  font-size: 9px;
  color: #fff;
  background-color: #ff976a;
  padding: 1px 4px;
  border-radius: 2px;
  font-weight: 500;
  margin-right: 4px;
}
.coupon-view {
  display: flex;
  align-items: center;
  margin-right: 4px;
  .cv-tag {
    height: 14px;
    background: linear-gradient(to right, #fb275a, #ff5d84);
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 3px;
  }
  .cv-tag-text {
    font-size: 10px;
    color: #ffffff;
    line-height: 1;
  }
  .cv-detail {
    height: 14px;
    background-color: #fff3f7;
    border-radius: 2px;
    padding: 0 3px;
    display: flex;
    align-items: center;
  }
  .cv-detail-text {
    color: #fd185e;
    font-size: 10px;
    line-height: 1;
  }
}
.bottom-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 6px;
  gap: 8px;
}
.btn {
  height: 26px;
  padding: 0 12px;
  border-radius: 13px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  cursor: pointer;
  &.btn-left {
    border: 1px solid #333;
    color: #333;
  }
  &.btn-left-status {
    color: #BF9264;
    border: 1px solid #BF9264;
    background: #fff;
    .true-icon {
      margin-right: 3px;
      font-size: 12px;
      color: #BF9264;
    }
  }
  &.btn-right {
    border: 1px solid #BF9264;
    color: #BF9264;
    background: #fff;
    font-weight: 500;
  }
}
</style>
